<template>
  <div class="foot-main">
    <!-- <router-view /> -->
    <div class="foot">
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/newindex/foot.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <div class="foot-info">
          <div class="foot-info-one">版权所有:北京朗杰科技有限公司</div>
         <div class="foot-info-one"><a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备14019303号-1</a></div>
      </div>
     
    </div>
    <allMenu></allMenu>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {
    allMenu: () => import("@/components/menu/allMenu")
  },
};
</script>

<style lang="less" scoped>

.foot-main {
  width: 100%;
}
.foot {
  width: 100%;
  height: 190px;
}
.foot-info{
  width: 100%;
  height: 20px;
  font-size: 12px;
}
.foot-info-one{
  width: 100%;
  height: 15px;
  text-align: center;
}
</style>
